<script lang="ts" setup>
  import { useSkins } from '@core/composable/useSkins';
  import { useThemeConfig } from '@core/composable/useThemeConfig';

  // @layouts plugin

  import DefaultLayoutWithHorizontalNav from '@/layouts/components/DefaultLayoutWithHorizontalNav.vue';
  import DefaultLayoutWithVerticalNav from '@/layouts/components/DefaultLayoutWithVerticalNav.vue';
  import { useCommonStore } from '@/stores/agency/common';
  import { useAdditionalSettingsStore } from '@/stores/agency/settings/agency/additional-settings';
  import { useAgencyStore } from '@/stores/agency/settings/agency/profile';
  import { AppContentLayoutNav } from '@layouts/enums';

  const { width: windowWidth } = useWindowSize();
  const { appContentLayoutNav, switchToVerticalNavOnLtOverlayNavBreakpoint } = useThemeConfig();

  const commonStore = useCommonStore();
  const commonState = computed(() => commonStore.$state);
  const agencyStore = useAgencyStore();
  const additionalSettingsStore = useAdditionalSettingsStore();

  onMounted(async () => {
    await agencyStore.fetchAgencyProfile();
    await additionalSettingsStore.fetchAdditionalSettings();

    await nextTick();

    commonStore.getTimeSlots();
  });

  // ℹ️ This will switch to vertical nav when define breakpoint is reached when in horizontal nav layout
  // Remove below composable usage if you are not using horizontal nav layout in your app
  switchToVerticalNavOnLtOverlayNavBreakpoint(windowWidth);

  const { layoutAttrs, injectSkinClasses } = useSkins();

  injectSkinClasses();
</script>

<template>
  <template v-if="appContentLayoutNav === AppContentLayoutNav.Vertical">
    <DefaultLayoutWithVerticalNav v-bind="layoutAttrs" />
  </template>
  <template v-else>
    <DefaultLayoutWithHorizontalNav v-bind="layoutAttrs" />
  </template>

  <VSnackbar
    v-model="commonState.snackBar.show"
    location="top end"
    variant="flat"
    :color="commonState.snackBar.color"
    :timeout="commonState.snackBar.timeout"
  >
    {{ commonState.snackBar.text }}
    <template #actions>
      <VIcon size="20" icon="tabler-x" class="me-3" @click="commonState.snackBar.show = false" />
    </template>
  </VSnackbar>
</template>

<style lang="scss">
  // As we are using `layouts` plugin we need its styles to be imported
  @use '@layouts/styles/default-layout';
</style>
